import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  NOTES_REFRESH: createSagaAction('NOTES_REFRESH'),

  NOTE_CREATE: createSagaAction('NOTE_CREATE'),
  NOTE_UPDATE: createSagaAction('NOTE_UPDATE'),
  NOTE_DELETE: createSagaAction('NOTE_DELETE'),

  // notes
  GET_SCHEDULE_NOTE: createSagaAction('GET_SCHEDULE_NOTE'),
  CREATE_SCHEDULE_NOTE: createSagaAction('CREATE_SCHEDULE_NOTE'),
  EDIT_SCHEDULE_NOTE: createSagaAction('EDIT_SCHEDULE_NOTE'),
  DELETE_SCHEDULE_NOTE: createSagaAction('DELETE_SCHEDULE_NOTE')
}

// Action Creators
export const actions = {
  jobNotesRefresh: ({ jobId }) => ({
    type: constants.NOTES_REFRESH.ACTION,
    jobId
  }),

  createNote: ({ jobId, content, userId }) => ({
    type: constants.NOTE_CREATE.ACTION,
    jobId,
    content,
    userId
  }),

  updateNote: ({ jobId, noteId, userId, content }) => ({
    type: constants.NOTE_UPDATE.ACTION,
    jobId,
    noteId,
    userId,
    content
  }),

  deleteNote: ({ noteId, jobId }) => ({
    type: constants.NOTE_DELETE.ACTION,
    jobId,
    noteId
  }),

  // notes
  getScheduleNote: ({ jobId }) => ({
    type: constants.GET_SCHEDULE_NOTE.ACTION,
    jobId
  }),
  createScheduleNote: ({ content, userId, jobId }) => ({
    type: constants.CREATE_SCHEDULE_NOTE.ACTION,
    content,
    userId,
    jobId
  }),
  editScheduleNote: ({ content, noteId, jobId }) => ({
    type: constants.EDIT_SCHEDULE_NOTE.ACTION,
    content,
    noteId,
    jobId
  }),
  deleteScheduleNote: ({ noteId, jobId }) => ({
    type: constants.DELETE_SCHEDULE_NOTE.ACTION,
    noteId,
    jobId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.NOTES_REFRESH.SUCCESS:
      return {
        ...state,
        notes: action.payload
      }
    case constants.NOTE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.NOTE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.NOTE_DELETE.SUCCESS:
      return {
        ...state
      }
    // NOTES
    case constants.GET_SCHEDULE_NOTE.SUCCESS:
      return { ...state, scheduleNotes: action.scheduleNotes }

    case constants.CREATE_SCHEDULE_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_SCHEDULE_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_SCHEDULE_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_SCHEDULE_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_SCHEDULE_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_SCHEDULE_NOTE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobNoteActions.js